import Inline from './inline';
import Inset from './inset';
import Stack from './stack';

export default { Inline, Inset, Stack };
